import { render } from "./ServicesHome.vue?vue&type=template&id=bd1f131e&scoped=true"
const script = {}

import "./ServicesHome.vue?vue&type=style&index=0&id=bd1f131e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bd1f131e"

export default script